/* eslint-disable import/prefer-default-export */

export const mobile = '(max-width: 790px)';
